<template>
  <div
    class="breadcrumb align-items-center py-2"
    :class="{ 'mb-0': $route.meta.container === false }"
  >
    <ol class="d-flex m-0 p-0">
      <li
        class="breadcrumb-item"
        v-for="(item, index) in breadcrumbs"
        :key="index"
      >
        <span v-if="index === breadcrumbs.length - 1" class="active">{{
          item.text
        }}</span>
        <router-link
          v-else
          :id="`breadcumb-${item.path.slice(1) || 'root'}`"
          :to="{ path: item.path || '/' }"
          >{{ item.text }}</router-link
        >
      </li>
    </ol>

    <b-btn class="ml-auto" variant="primary" to="/activate">
      <i class="icon-key" />
      Authenticate Device
    </b-btn>

    <b-btn
      class="ml-2"
      variant="primary"
      @click="$root.$emit('create-meeting', true)"
    >
      <i class="icon-calendar" />
      Schedule meeting
    </b-btn>
  </div>
</template>

<script>
export default {
  name: "breadcrumbs",

  computed: {
    breadcrumbs() {
      if (this.$route.fullPath === "/dashboard") {
        return [{ text: "Home" }];
      }

      const routes = this.$route.matched.reduce((routes, route) => {
        // Make sure same path child routes (path: "") do not show up twice in breadcrumbs.
        if (route.parent && route.path === route.parent.path) {
          return routes;
        }
        if (route.parent && route.path === `${route.parent.path}/`) {
          return routes;
        }

        route.text = this.getText(route);

        routes.push(route);
        return routes;
      }, []);

      return routes;
    }
  },

  methods: {
    getText(item) {
      if (item.meta && item.meta.title) {
        return item.meta.title;
      }
      if (item.name) {
        return item.name;
      }
      return item.path;
    }
  }
};
</script>
